import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import placholderImage from '../../assets/physiotherapist-and-boy-holding-ball-pxfq-9-hy.png';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import StarRating from '../widgets/StarRating.js';
import Button from '../Button.js';
import Box from '@material-ui/core/Box';
import Skeleton from '@material-ui/lab/Skeleton';

const skeletonStyles = makeStyles(theme => ({
  root: {
    flex: '0 0 22.5rem',
    height: '32rem',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16);',
    borderRadius: 0,
    marginRight: '2rem',
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 20rem',
    },
  },
  media: {
    height: '12rem',
    width: '100%',
  },
  content: {
    height: '16rem',
  },
}));

const SkeletonCard = () => {
  const classes = skeletonStyles();
  return (
    <Card className={classes.root}>
      <CardMedia>
        <Skeleton variant='rect' animation="wave" height={190}/>
      </CardMedia>
      <CardContent className={classes.content}>
        <Skeleton variant='rect' animation="wave" height={160}/>
      </CardContent>
    </Card>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    flex: '0 0 22.5rem',
    height: '32rem',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16);',
    borderRadius: 0,
    marginRight: '2rem',
    [theme.breakpoints.down('sm')]: {
      flex: '0 0 20rem',
    },
  },
  media: {
    height: '12rem',
    width: '100%',
    backgroundColor: '#ccc',
  },
  content: {
    height: '16rem',
    '& h2': {
      fontWeight: 400,
    }
  },
  reviewer: {
    padding: '0.5rem 0',
  },
  // https://css-tricks.com/line-clampin/
  review: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    lineHeight: '1.8rem',
    height: '5.2rem',
    overflowY: 'hidden',
  },
  widgets: {
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0.5rem 0',
  },
  widgetText: {
    paddingLeft: '2px',
  },
  actions: {
    justifyContent: 'flex-end',
    padding: '1rem',
  },
}));

const CarouselCard = ({data=null}) => {
  const classes = useStyles();
  if (data === null) {
    return <SkeletonCard />;
  }
  const imageSize = '@360x192';
  const img = data.image_path ? data.image_path + imageSize : placholderImage;
  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={img}
        title={data.provider_name}
      />
      <CardContent className={classes.content}>
        <Typography gutterBottom variant="h2" color="primary">
          {data.provider_name}
        </Typography>
        <Box className={classes.widgets}>
          <StarRating rating={data.rating} />
          {/* Use this when we have more recent reviews...
            <Typography variant="body2" className={classes.widgetText}>
              {timeSinceText(data.created_at)}
            </Typography>
          */}
        </Box>
        <Typography variant="subtitle2" className={classes.reviewer}>
          {data.author_username}
        </Typography>
        <Typography variant="body2" className={classes.review} component="div">
          <i>{data.content}</i>
        </Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          aria-label="read more"
          label="Read more"
          variant="text"
          pointer="right"
          to={`/provider/${data.provider_slug}?tab=1`}
        />
      </CardActions>
    </Card>
  );
};

CarouselCard.propTypes = {
  data: PropTypes.object,
};

export default CarouselCard;
